var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoupe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 94,
    viewBox: "0 0 88 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4248 85.733C18.4053 85.733 0.488281 66.5216 0.488281 42.9112C0.488281 19.3008 18.4053 0.0893555 40.4248 0.0893555C62.4444 0.0893555 80.3613 19.3008 80.3613 42.9112C80.3613 66.5216 62.4444 85.733 40.4248 85.733ZM40.4248 7.87514C22.4098 7.87514 7.74947 23.5907 7.74947 42.9112C7.74947 62.2316 22.4098 77.9472 40.4248 77.9472C58.4398 77.9472 73.1001 62.2316 73.1001 42.9112C73.1001 23.5907 58.4398 7.87514 40.4248 7.87514Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9933 93.5194C83.5165 93.5199 83.0442 93.4194 82.6037 93.2237C82.1632 93.0279 81.7631 92.7408 81.4265 92.3788L64.0178 73.7124C63.337 72.9819 62.9547 71.9914 62.9551 70.9587C62.9554 69.926 63.3383 68.9358 64.0196 68.2059C64.7008 67.4759 65.6246 67.066 66.5877 67.0664C67.5508 67.0668 68.4743 67.4773 69.1551 68.2078L86.5601 86.8742C87.0695 87.4179 87.4167 88.1116 87.5578 88.8673C87.6988 89.623 87.6272 90.4065 87.3522 91.1185C87.0772 91.8305 86.6111 92.4389 86.013 92.8663C85.415 93.2938 84.712 93.5211 83.9933 93.5194Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupe);
export default __webpack_public_path__ + "static/media/Loupe.e930aa78ce59f64e1837edab82a6e51e.svg";
export { ForwardRef as ReactComponent };